// extracted by mini-css-extract-plugin
export default {"roleLabel":"roles_gantt-modules___roleLabel___f85c1c8f","tooltip":"roles_gantt-modules___tooltip___ab92985c","tooltipHeader":"roles_gantt-modules___tooltipHeader___e910dc18"};